export type RequestStatus = "Onay Bekliyor" | "Onaylandı" | "Reddedildi" | "Randevuya Dönüştü";

export interface OnlineAppointmentRequest {
  id: string;
  requestDate: string;
  customerName: string;
  phone: string;
  service: string;
  preference: string;
  timePreference: string;
  personCount: number;
  notes: string;
  source: string;
  status: RequestStatus;
  handledBy: string;
  handledAt: string;
}

export const onlineRequests: OnlineAppointmentRequest[] = [
  {
    id: "oar-001",
    requestDate: "2026-05-08 09:30",
    customerName: "Melis Öztürk",
    phone: "+90 532 777 9988",
    service: "Sıcak Taş Masajı (90 dk)",
    preference: "Bugün",
    timePreference: "14:00 - 16:00",
    personCount: 1,
    notes: "Sırt ağrısı var, hassas bölge.",
    source: "Instagram Bio",
    status: "Onay Bekliyor",
    handledBy: "",
    handledAt: "",
  },
  {
    id: "oar-002",
    requestDate: "2026-05-08 08:15",
    customerName: "Oğuzhan Karaca",
    phone: "+90 533 888 1122",
    service: "SPA Günü Paketi",
    preference: "Yarın",
    timePreference: "10:00 - 12:00",
    personCount: 2,
    notes: "Eşiyle birlikte gelecek, hediye paket istiyor.",
    source: "Google",
    status: "Onay Bekliyor",
    handledBy: "",
    handledAt: "",
  },
  {
    id: "oar-003",
    requestDate: "2026-05-07 19:45",
    customerName: "Ceren Aksoy",
    phone: "+90 534 999 3344",
    service: "Anti-Aging Cilt Bakımı",
    preference: "Bugün",
    timePreference: "11:00 - 13:00",
    personCount: 1,
    notes: "İlk kez gelecek, tanıtım istiyor.",
    source: "Meta",
    status: "Onaylandı",
    handledBy: "Seda Avcı",
    handledAt: "2026-05-07 20:30",
  },
  {
    id: "oar-004",
    requestDate: "2026-05-07 18:00",
    customerName: "Emir Taşkın",
    phone: "+90 535 111 5566",
    service: "Sporcu Masajı",
    preference: "Yarın",
    timePreference: "16:00 - 18:00",
    personCount: 1,
    notes: "Koşu sonrası ağrı için.",
    source: "WhatsApp",
    status: "Randevuya Dönüştü",
    handledBy: "Seda Avcı",
    handledAt: "2026-05-07 18:30",
  },
  {
    id: "oar-005",
    requestDate: "2026-05-07 14:20",
    customerName: "Nil Yılmazer",
    phone: "+90 536 222 7788",
    service: "Aromaterapi Masajı",
    preference: "Bugün",
    timePreference: "19:00 - 21:00",
    personCount: 1,
    notes: "Stres rahatlatma odaklı.",
    source: "Instagram Bio",
    status: "Reddedildi",
    handledBy: "Seda Avcı",
    handledAt: "2026-05-07 15:00",
  },
  {
    id: "oar-006",
    requestDate: "2026-05-06 21:10",
    customerName: "Berk Arslan",
    phone: "+90 537 333 9900",
    service: "Klasik Masaj (60 dk)",
    preference: "Yarın",
    timePreference: "09:00 - 11:00",
    personCount: 1,
    notes: "Bel ağrısı, doktor önerisi.",
    source: "Google",
    status: "Randevuya Dönüştü",
    handledBy: "Seda Avcı",
    handledAt: "2026-05-06 22:00",
  },
  {
    id: "oar-007",
    requestDate: "2026-05-06 16:00",
    customerName: "Pelin Çelik",
    phone: "+90 538 444 1122",
    service: "Detoks SPA Paketi",
    preference: "Bugün",
    timePreference: "13:00 - 15:00",
    personCount: 2,
    notes: "Arkadaşıyla birlikte, ilk kez.",
    source: "Tavsiye",
    status: "Onaylandı",
    handledBy: "Seda Avcı",
    handledAt: "2026-05-06 17:00",
  },
  {
    id: "oar-008",
    requestDate: "2026-05-06 11:30",
    customerName: "Umut Demir",
    phone: "+90 539 555 3344",
    service: "Profesyonel Pedikür + Manikür",
    preference: "Yarın",
    timePreference: "14:00 - 16:00",
    personCount: 1,
    notes: "Bayram öncesi bakım.",
    source: "Meta",
    status: "Onay Bekliyor",
    handledBy: "",
    handledAt: "",
  },
];